import { useAnalyticsContext } from 'app/modules/analytics/context/AnalyticsContext';
import type { PageData, ProfileGroup } from 'types/Page';

export interface AnalyticsSelection {
  selectedPage: PageData | null;
  selectedPageId: number | null;
  selectedGroupId: number | null;
  selectedProfileGroup: ProfileGroup | null;
  isGroupSelected: boolean;
  enabledGroupPageIds: ReadonlySet<number>;
  toggleGroupPageId: (pageId: number) => void;
  selectPage: (page: PageData) => void;
  selectGroup: (groupId: number) => void;
  markAwaitingCreatedGroup: () => void;
  markAwaitingCreatedProfile: () => void;
}

/** Selection still lives in AnalyticsProvider; this names the layer consumers depend on. */
export function useAnalyticsSelection(): AnalyticsSelection {
  const {
    selectedPage,
    selectedPageId,
    selectedGroupId,
    selectedProfileGroup,
    isGroupSelected,
    enabledGroupPageIds,
    toggleGroupPageId,
    selectPage,
    selectGroup,
    markAwaitingCreatedGroup,
    markAwaitingCreatedProfile,
  } = useAnalyticsContext();

  return {
    selectedPage,
    selectedPageId,
    selectedGroupId,
    selectedProfileGroup,
    isGroupSelected,
    enabledGroupPageIds,
    toggleGroupPageId,
    selectPage,
    selectGroup,
    markAwaitingCreatedGroup,
    markAwaitingCreatedProfile,
  };
}
